<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                Welcome back!
                <br />
                Great to see you again
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background">
        <form @submit.prevent="register" @keydown="clearError($event)" autocomplete="no">
          <div class="form-row">
            <div class="col">
              <input
                v-model="company.organization"
                id="organization"
                name="organization"
                type="text"
                class="form-control login-input"
                placeholder="Organization name"
                @keydown="clearError($event)"
              />
              <error-field :errors="errors" field="organization" />
            </div>
            <div class="col">
              <input
                v-model="company.email"
                id="email"
                name="email"
                type="text"
                class="form-control login-input"
                placeholder="Email"
                @keydown="clearError($event)"
              />
              <error-field :errors="errors" field="email" />
            </div>
          </div>
          <input type="submit" class="btn btn-primary form-control login-button"
                 value="Register"
                 :disabled="errors.any()"
          />
        </form>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col">
            <router-link class="thick-font" to="login">Have an account? Login</router-link>
            <br />
            <p class="info-text">MOD24 is free for customers</p>
          </div>
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  name: 'Register',
  components: {
    ErrorField,
  },
  data: () => ({
    company: {
      organization: '',
      email: '',
    },
    errors: new Errors(),
  }),
  methods: {
    register() {
      axios
        .post('companies/register', { ...this.company })
        .then(() => {
          this.$router.push('verify');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue